// extracted by mini-css-extract-plugin
export var modalFooter = "_nn-0";